/// <amd-dependency path='VSS/LoaderPlugins/Css!WorkItemArea' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import * as SelectWorkItemView from "TestManagement/Scripts/TFS.TestManagement.SelectWorkItemView";
import * as Resources from "TestManagement/Scripts/Resources/TFS.Resources.TestManagement";
import * as TestsOM from "TestManagement/Scripts/TFS.TestManagement";
import * as Dialogs from "VSS/Controls/Dialogs";

export interface ICreateNewQBSDialogProps {
    onSuccess(queryName: string, queryText: string): void;
    areaPath: string;
    createSave: boolean;
    queryText: string;
}

// This is a proxy component to load the query selector dialog using LegacyComponent
class CreateNewQBSProxy extends React.Component<ICreateNewQBSDialogProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();
        Dialogs.show(SelectWorkItemView.CreateQueryBasedSuiteDialog, {
            width: windowWidth >= 1024 ? $(window).width() * 0.8 : $(window).width(),
            height: windowHeight >= 768 ? $(window).height() * 0.8 : $(window).height(),
            attachResize: true,
            resizable: false,
            dynamicSize: true,
            widthPct: windowWidth >= 1024 ? 0.8 : 1,
            heightPct: windowHeight >= 768 ? 0.8 : 1,
            okText: this.props.createSave ? Resources.CreateSuite : Resources.SaveQueryText,
            okCallback: (queryName: string, queryText: string) => {
                this.props.onSuccess(queryName, queryText);
            },
            title: this.props.createSave ? Resources.CreateQueryBasedSuiteTitle.toLocaleUpperCase() : Resources.EditQuery.toLocaleUpperCase(),
            workItemCategories: [
                TestsOM.WorkItemCategories.TestCase
            ],
            hideQueryType: false,
            persistenceId: SelectWorkItemView.PersistenceIds.CREATE_QUERY_BASED_SUITE_ID,
            supportWorkItemOpen: true,
            queryText: this.props.createSave ? TestsOM.TestPlanSelectionHelper.getDefaultQuery() : this.props.queryText,
            newSuiteMode: this.props.createSave ? true : false,
            areaPath: this.props.areaPath
        });
    }
}

registerLWPComponent("create-qbs-dialog-proxy", CreateNewQBSProxy);
